<template>
    <div>
        <Administracao style="height: 100%;"/>
    </div>
</template>

<script>
import Administracao from '../components/Administracao/Administracao'
export default {
  components: {
    Administracao
  },
  beforeMount () {
    this.$emit('loadDados')
  }
}
</script>

<style>

</style>
